var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component"},[_vm._t("default"),_vm._l((_vm.urlifiedMessages),function(i,index){return [(i.type === _vm.type.URL)?_c('a',{key:index,attrs:{"href":i.href,"target":"_blank"}},[_c('u',[_vm._v(_vm._s(i.value))])]):[_vm._v(_vm._s(i.value))]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }